import * as base from './base.js'
const baseName = '/admin/system/common'

const commondescr = baseName + '/list'

const obj = base.setBaseUrl('commondescr', baseName)

const a = Object.assign(obj, { commondescr })
export default a
